<template>
  <generic-modal :title="$t('message')" :buttons="buttons" ref="generic_modal">
    <div v-if="meta && meta.outbox_message">
      <div class="timeline">
        <header class="timeline-header">
          <span class="tag is-medium is-primary">{{ $t("start") }}</span>
        </header>
        <div
          class="timeline-item pb-0"
          v-for="log in meta.outbox_message.status_log"
          :key="log.uuid"
        >
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">{{ format_date_time(log.date) }}</p>
            <p>{{ log.name }}</p>
            <p>{{ log.message }}</p>
          </div>
        </div>
      </div>
      <!-- <pre>{{ meta.outbox_message.status_log }}</pre> -->
    </div>
    <div v-else>
      <div class="notification is-info">
        <p>{{ $t("no outbox message yet") }}</p>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date_time,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "MessageModal",
  components: { GenericModal },
  data() {
    return {
      buttons: [
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    format_date_time,
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(message_uuid) {
      let v = this;
      v.set_initial_state();
      get("/emarketing/message", { uuid: message_uuid })
        .then((message) => {
          v.meta = message;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
